import SideMenu from '@/containers/side-menu/SideMenu.vue'
import WalletReversal from '@/pages/wallet-reversal/WalletReversal.vue'

export default {
  path: '/wallet-reversal',
  name: 'WalletReversal',
  components: {
    mainContent: WalletReversal,
    mainMenu: SideMenu
  },
  meta: {
    role: {
      sectorId: 'wallet-reversal'
    },
    breadcrumb: {
      title: 'Estorno de crédito da carteira',
      paths: [
        { title: 'carteira' },
        { title: 'Estorno' },
      ]
    }
  }
}